/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module UserProfileModule
 */

const moduleName = 'user-profile';
const componentName = 'user-profile-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalHeaderEdit = `${prefix}.modalHeaderEdit`;
export const modalHeaderNew = `${prefix}.modalHeaderNew`;
export const nameInputLabel = `${prefix}.nameInputLabel`;
export const maxConcurrentSessionsInputLabel = `${prefix}.maxConcurrentSessionsInputLabel`;
export const nameInputPlaceholder = `${prefix}.nameInputPlaceholder`;
export const maxConcurrentSessionsInputPlaceholder = `${prefix}.maxConcurrentSessionsPlaceholder`;
export const sectionTitleGeneral = `${prefix}.sectionTitleGeneral`;
export const sectionTitlePasswordComplexity = `${prefix}.sectionTitlePasswordComplexity`;
export const sectionTitlePasswordExpiration = `${prefix}.sectionTitlePasswordExpiration`;
export const sectionTitleAccountLockout = `${prefix}.sectionTitleAccountLockout`;

// Complexity Constraint fields
export const minLengthInputLabel = `${prefix}.minLengthInputLabel`;
export const minLengthInputPlaceholder = `${prefix}.minLengthInputPlaceholder`;
export const minUppercaseInputLabel = `${prefix}.minUppercaseInputLabel`;
export const minUppercaseInputPlaceholder = `${prefix}.minUppercaseInputPlaceholder`;
export const minLowercaseInputLabel = `${prefix}.minLowercaseInputLabel`;
export const minLowercaseInputPlaceholder = `${prefix}.minLowercaseInputPlaceholder`;
export const minSpecialInputLabel = `${prefix}.minSpecialInputLabel`;
export const minSpecialInputPlaceholder = `${prefix}.minSpecialInputPlaceholder`;
export const minNumericInputLabel = `${prefix}.minNumericInputLabel`;
export const minNumericInputPlaceholder = `${prefix}.minNumericInputPlaceholder`;
export const passwordHistoryCountInputLabel = `${prefix}.passwordHistoryCountInputLabel`;
export const passwordHistoryInputPlaceholder = `${prefix}.passwordHistoryInputPlaceholder`;

// Expiration Constraint fields
export const passwordExpirationDaysInputLabel = `${prefix}.passwordExpirationDaysInputLabel`;
export const passwordExpirationDaysInputPlaceholder = `${prefix}.passwordExpirationDaysInputPlaceholder`;
export const passwordExpirationDaysHelperText = `${prefix}.passwordExpirationDaysHelperText`;

// Lockout Constraint fields
export const lockoutMaxAuthFailuresInputLabel = `${prefix}.lockoutMaxAuthFailuresInputLabel`;
export const lockoutMaxAuthFailuresInputPlaceholder = `${prefix}.lockoutMaxAuthFailuresInputPlaceholder`;
export const lockoutEvaluationPeriodInputLabel = `${prefix}.lockoutEvaluationPeriodInputLabel`;
export const lockoutEvaluationPeriodInputPlaceholder = `${prefix}.lockoutEvaluationPeriodInputPlaceholder`;
export const lockoutEvaluationPeriodHelperText = `${prefix}.lockoutEvaluationPeriodHelperText`;
export const lockoutPeriodInputLabel = `${prefix}.lockoutPeriodInputLabel`;
export const lockoutPeriodInputPlaceholder = `${prefix}.lockoutPeriodInputPlaceholder`;
export const lockoutPeriodHelperText = `${prefix}.lockoutPeriodHelperText`;
export const passwordPolicyManagedByVcfOpsWarning = `${prefix}.passwordPolicyManagedByVcfOpsWarning`;

export const ENGLISH = {
    [modalHeaderEdit]: 'Edit User Profile',
    [modalHeaderNew]: 'New User Profile',
    [nameInputLabel]: 'Name',
    [maxConcurrentSessionsInputLabel]: 'Max Concurrent Sessions',
    [nameInputPlaceholder]: 'Enter Name',
    [maxConcurrentSessionsInputPlaceholder]: 'Enter Max Concurrent Sessions',
    [sectionTitleGeneral]: 'General',
    [sectionTitlePasswordComplexity]: 'Password Complexity',
    [sectionTitlePasswordExpiration]: 'Password Expiration',
    [sectionTitleAccountLockout]: 'Account Lockout',
    [minLengthInputLabel]: 'Minimum Length',
    [minLengthInputPlaceholder]: 'Enter Minimum Length',
    [minUppercaseInputLabel]: 'Minimum Uppercase Characters',
    [minUppercaseInputPlaceholder]: 'Enter Minimum Uppercase Characters',
    [minLowercaseInputLabel]: 'Minimum Lowercase Characters',
    [minLowercaseInputPlaceholder]: 'Enter Minimum Lowercase Characters',
    [minSpecialInputLabel]: 'Minimum Special Characters',
    [minSpecialInputPlaceholder]: 'Enter Minimum Special Characters',
    [minNumericInputLabel]: 'Minimum Numeric Characters',
    [minNumericInputPlaceholder]: 'Enter Minimum Numeric Characters',
    [passwordHistoryCountInputLabel]: 'Password History Count',
    [passwordHistoryInputPlaceholder]: 'Enter Password History Count',
    [passwordExpirationDaysInputLabel]: 'Password Expiration Days',
    [passwordExpirationDaysInputPlaceholder]: 'Enter Password Expiration Days',
    [passwordExpirationDaysHelperText]: 'Days (0 = No password expiry)',
    [lockoutMaxAuthFailuresInputLabel]: 'Max Authentication Failures',
    [lockoutMaxAuthFailuresInputPlaceholder]: 'Enter Max Authentication Failures',
    [lockoutEvaluationPeriodInputLabel]: 'Evaluation Period',
    [lockoutEvaluationPeriodInputPlaceholder]: 'Enter Evaluation Period',
    [lockoutEvaluationPeriodHelperText]: 'Seconds (0 = Do not reset on basis of evaluation window)',
    [lockoutPeriodInputLabel]: 'Lockout Period',
    [lockoutPeriodInputPlaceholder]: 'Enter Lockout Period',
    [lockoutPeriodHelperText]: 'Seconds',
    [passwordPolicyManagedByVcfOpsWarning]: 'The password policy for this component is managed through VCF Operations. Please go to VCF Operations to manage the password policy.',
};
